<template>
    <form
        :action="autocompleteUrl"
        v-on:submit.prevent="search"
        method="get"
        accept-charset="utf-8"
        class="c-form"
    >
        <div class="c-form__item c-form__item--text">
            <input
                type="text"
                :id="'autocomplete-' + parseInt(Math.random() * 1000)"
                @input="onInput"
                name="search"
                autocomplete="off"
                :placeholder="inputPlaceholder"
                :value="keyword"
                @focus="showForm"
                @keyup.enter="redirectToSearch"
                :class="{
                    'c-form__input': true,
                    'is-empty': !keyword,
                    'is-open': isOpen
                }"
                ref="searchInput"
            />
        </div>

        <a
            :href="`/vyhladavanie${keyword ? `?search=${keyword}` : ''}`"
            class="c-btn is-search"
            :class="{
                'is-loading': isLoading,
                'is-open': isOpen,
                'c-btn--primary': isBabys,
                'c-btn--secondary': !isBabys,
            }"
        >
            <i class="ico ico-search"></i>
        </a>

        <button
            type="button"
            @click="hideForm"
            class="c-btn is-close"
            :class="{
                'is-loading': isLoading,
                'is-open': isOpen
            }"
        >
            <i aria-hidden="true" class="ico ico-close"></i>
        </button>
    </form>
</template>

<script>
import RshopAutocompleteForm from "FrontendComponents/Autocomplete/Form/index.vue";

export default {
    extends: RshopAutocompleteForm,
    data() {
        return {
            isBabys: window.Eshop.options.projectName === 'babys',
            isSlate: window.Eshop.options.projectName === 'slate',
            isMlongauer: window.Eshop.options.projectName === 'mlongauer',
        }
    },
    props: {
        isFormVisible: {
            type: Boolean,
            default: false,
        },
        isOpen: {
            type: Boolean,
            default: false,
        },
        inputPlaceholder: {
            type: String,
            required: true
        }
    },
    methods: {
        showForm() {
            this.$emit('show-form')
        },
        hideForm() {
            this.$emit('hide-form')
        },
        onInput(event) {
            this.keyword = event.target.value

            this.search()
        },
        redirectToSearch() {
            window.location.href = this.searchUrl
        }
    },
    computed: {
        searchUrl() {
            return `/vyhladavanie${this.keyword ? `?search=${this.keyword}` : ''}`
        }
    },
    watch: {
        isFormVisible(value) {
            if (value) {
                this.$nextTick(() => {
                    this.$refs.searchInput.focus()
                })
            }
        }
    }
};
</script>
